<!--
 * @Description: 
 * @Author: Lizhiliang
 * @Date: 2022-12-29 11:29:08
 * @LastEditTime: 2023-01-11 17:10:25
 * @LastEditors: lizhiliang
 * @Usage: 
-->
<template>
    <ux-form
      class="my-vertical-form"
      ref="form"
      width="430px"
      :data="formData"
      :rules="rules">
        <ux-form-item :label="$t('HT.workList.uploadImg')" class="ux-upload-image" required prop="imagelist">
            <ux-upload
              ref="upload"
              :class="formData.imagelist.length >= 1 ? 'hide-upload' : ''"
              :list="formData.imagelist"
              type="drag"
              accept="image/jpeg, image/png, image/bmp"
              :multiple="false"
              :limit="1"
              :size="1024 * 5"
              :exceed="exceed"
            ></ux-upload>
        </ux-form-item>
        <div class="upload-tip">
            <p>1. {{ $t('HT.photo.unobstructed.frontal') }}</p>
            <p>2. {{ $t('HT.only.support.picture', {max: 5}) }}</p>
            <p>3. {{ $t('HT.contains.face') }}</p>
            <p>4. {{ $t('HT.upload.maxLength', {max: 1}) }}</p>
        </div>
    </ux-form>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          image_type: 'URL',
          imagelist: [],
          image: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addFaceUser()
    };
  },

  methods: {
    // 图片超出限制
    exceed() {
      this.$message.closeAll();
      this.$message.error(this.$t('HT.uploadImage.error', {max: 1, num: 5}));
    }
  },
};
</script>

<style lang="scss" scoped>
.ux-upload-image {
    margin-bottom: 0 !important;
}
.upload-tip {
    margin-top: 25px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8690AA;
    line-height: 16px;
}
.ux-show-modal .ux-modal-box .ux-content > .el-form.my-vertical-form {
  padding: 19px 56px 0 56px;
}
::v-deep .hide-upload .el-upload {
  display: none;
}
</style>